import * as React from 'react';

import { darken, transparentize } from 'polished';
import styled from 'styled-components';

import { COLOR, FONT_SIZE, RADIUS, SPACING } from '../../packages/constants';

export interface PasswordInputProps {
    autoComplete?: string;
    autoFocus?: boolean;
    dataId: string;
    defaultValue?: string | string[];
    disabled?: boolean;
    id: string;
    invalid?: boolean;
    maxLength?: number;
    minLength?: number;
    pattern?: string;
    readOnly?: boolean;
    name: string;
    onChange?: (e: any) => void;
    placeholder?: string;
    required?: boolean;
    value?: string | string[] | number;
    className?: string;
}

interface StyledInputProps {
    disabled?: boolean;
    invalid?: boolean;
}

const StyledInput = styled.input<StyledInputProps>`
    background-color: ${(props: StyledInputProps): string =>
        props.disabled ? darken('0.1', COLOR.PRIMARY.WHITE) : COLOR.PRIMARY.WHITE};
    color: ${(props: StyledInputProps): string =>
        props.disabled ? transparentize('0.5', COLOR.PRIMARY.BLACK) : COLOR.PRIMARY.BLACK};
    font-size: ${FONT_SIZE.SMALL};
    line-height: ${FONT_SIZE.MEDIUM};
    padding: ${SPACING.SMALL};
    border-width: 1px;
    border-style: solid;
    border-color: ${(props: StyledInputProps): string => (props.invalid ? COLOR.PRIMARY.RED : COLOR.MAIN.FORM_FIELD)};
    border-radius: ${RADIUS.DEFAULT};

    &::placeholder {
        opacity: 0.65;
    }
`;

export const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
    (
        {
            autoComplete,
            autoFocus,
            dataId,
            defaultValue,
            disabled,
            id,
            invalid,
            maxLength,
            minLength,
            pattern,
            readOnly,
            name,
            placeholder,
            required,
            value,
            onChange,
        },
        ref,
    ) => {
        return (
            <StyledInput
                type="password"
                aria-label={id}
                autoComplete={autoComplete}
                autoFocus={autoFocus}
                data-test-id={dataId}
                {...(typeof defaultValue !== 'undefined' && { defaultValue })}
                disabled={disabled}
                id={id}
                invalid={invalid}
                maxLength={maxLength}
                minLength={minLength}
                inputMode={'text'}
                pattern={pattern}
                readOnly={readOnly}
                name={name}
                onChange={onChange}
                placeholder={placeholder}
                ref={ref}
                required={required}
                {...(typeof value !== 'undefined' && { value })}
            />
        );
    },
);
PasswordInput.displayName = 'PasswordInput';
